import { useState } from 'react';
import { t } from 'i18next';
import { AttemptCardWrapper, AttemptCard as AttCard, AttemptCardTitle } from '@/components/custom/attempt';
import { FiCheck, FiChevronDown, FiChevronUp, FiX } from 'react-icons/fi';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import api from '@/services/api';
import toast from 'react-hot-toast';

export function DiscursiveQuestionCard({ question, onUpdateQuestion }) {
  const [isExpanded, setIsExpanded] = useState(question?.answer?.['corrected-at'] ? false : true);
  const [correctionFeedback, setCorrectionFeedback] = useState('');

  const sendCorrectionQuestion = async option => {
    const payload = {
      is_correct: option,
      feedback: correctionFeedback
    };

    try {
      const { data, error } = await api.patch(`/answers/${question?.answer?.id}/correct`, payload);
      if (error) {
        toast.error('Erro ao corrigir questão discursiva');
      } else {
        const updatedQuestion = {
          ...question,
          answer: {
            ...question.answer,
            feedback: correctionFeedback,
            'is-correct': option
          }
        };
        onUpdateQuestion(updatedQuestion);
      }
    } catch (error) {
      toast.error('Erro ao corrigir questão discursiva');
    }
  };

  return (
    <AttemptCardWrapper className={`mt-6 p-0 ${true ? 'mb-3' : ''}`}>
      <AttCard
        className="items-center p-3"
        onClick={() => setIsExpanded(prev => !prev)}
      >
        <AttemptCardTitle>
          <Badge
            variant="bright"
            square
            size="sm"
            className="text-primary-dark"
          >
            Q{question?.id}
          </Badge>
        </AttemptCardTitle>

        {question?.answer?.['corrected-at'] && <span className={`text-sm font-semibold ${question?.answer?.['is-correct'] ? 'text-success' : 'text-danger'}`}>{question?.answer?.['is-correct'] ? 'Acertou' : 'Errou'}</span>}
        <div className="flex items-center gap-2">
          <Badge
            variant={question?.answer?.['corrected-at'] ? 'success' : 'danger'}
            size="xs"
          >
            {question?.answer?.['corrected-at'] ? 'Corrigida' : 'Não corrigida'}
          </Badge>
          {isExpanded ? (
            <FiChevronUp
              className="text-primary"
              size={20}
            />
          ) : (
            <FiChevronDown
              className="text-primary"
              size={20}
            />
          )}
        </div>
      </AttCard>
      {isExpanded && (
        <div className="flex flex-col gap-2 bg-white p-2 text-sm text-primary-dark">
          <div className="rounded bg-neutral-bright p-3">
            <span className="font-bold">Enunciado</span>
            <p
              className="text-neutral"
              dangerouslySetInnerHTML={{ __html: question?.description }}
            />
          </div>
          <div className="rounded bg-neutral-bright p-3">
            <span className="font-bold">Resposta do aluno</span>
            <p>{question?.answer?.content}</p>

            {question?.answer?.['corrected-at'] && question?.answer?.feedback ? (
              <div className="mt-3 rounded bg-white p-3 text-xs text-neutral-darker">
                <span className="font-bold text-neutral">Comentário do professor</span>
                <p>{question?.answer?.feedback}</p>
              </div>
            ) : (
              <div>
                <textarea
                  className="mt-3 w-full rounded border p-3"
                  placeholder="Comentários do professor"
                  rows={1}
                  onChange={e => setCorrectionFeedback(e.target.value)}
                />
                <div className="mt-3 flex gap-3">
                  <Button
                    variant="outline-success"
                    size="sm"
                    type="button"
                    onClick={() => sendCorrectionQuestion(true)}
                  >
                    <FiCheck className="h-5 w-5" />
                    Resposta correta
                  </Button>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    type="button"
                    onClick={() => sendCorrectionQuestion(false)}
                  >
                    <FiX className="h-5 w-5" />
                    Resposta incorreta
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </AttemptCardWrapper>
  );
}
